// import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <div>
      <>
        {/* <footer className="footer inner-footer footer-info">
          <div className="footer-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <div className="row">
                    <div className="col-lg-3 col-md-3">
                      <div className="footer-widget footer-menu">
                        <h6 className="footer-title">Company</h6>
                        <ul>
                          <li>
                            <Link to="#">Careers</Link>
                          </li>
                          <li>
                            <Link to="#">Features</Link>
                          </li>
                          <li>
                            <Link to="#">About Howzit!</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3">
                      <div className="footer-widget footer-menu">
                        <h6 className="footer-title">Celebrities</h6>
                        <ul>
                          <li>
                            <Link to="#">Ethics</Link>
                          </li>
                          <li>
                            <Link to="#">Requirements</Link>
                          </li>
                          <li>
                            <Link to="#">Brand protection</Link>
                          </li>
                         
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3">
                      <div className="footer-widget footer-menu">
                        <h6 className="footer-title">Fields</h6>
                        <ul>
                          <li>
                            <Link to="#">Film</Link>
                          </li>
                          <li>
                            <Link to="#">Sports</Link>
                          </li>
                          <li>
                            <Link to="#">Social media</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3">
                      <div className="footer-widget footer-menu">
                        <h6 className="footer-title">Utilites</h6>
                        <ul>
                          <li>
                            <Link to="#">Pricing</Link>
                          </li>
                          <li>
                            <Link to="#">Contact</Link>
                          </li>
                          <li>
                            <Link to="#">Merchandise sale</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-7">
                  <div className="footer-widget">
                    <h6 className="footer-title">Newsletter</h6>
                    <p className="mb-2">
                      Subscribe &amp; Stay Updated from the Howzit!
                    </p>
                    <div className="subscribe-input">
                      <form action="#">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email Address"
                        />
                        <button
                          type="submit"
                          className="btn btn-md btn-primary-gradient d-inline-flex align-items-center"
                        >
                          <i className="isax isax-send-25 me-1" />
                          Send
                        </button>
                      </form>
                    </div>
                    <div className="social-icon">
                      <h6 className="mb-3">Connect With Us</h6>
                      <ul>
                        <li>
                          <Link to="#">
                            <i className="fa-brands fa-facebook" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fa-brands fa-x-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fa-brands fa-instagram" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fa-brands fa-linkedin" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fa-brands fa-pinterest" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bg">
              <img
                src="assets/img/bg/footer-bg-01.png"
                alt="img"
                className="footer-bg-01"
              />
              <img
                src="assets/img/bg/footer-bg-02.png"
                alt="img"
                className="footer-bg-02"
              />
              <img
                src="assets/img/bg/footer-bg-03.png"
                alt="img"
                className="footer-bg-03"
              />
              <img
                src="assets/img/bg/footer-bg-04.png"
                alt="img"
                className="footer-bg-04"
              />
              <img
                src="assets/img/bg/footer-bg-05.png"
                alt="img"
                className="footer-bg-05"
              />
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              <div className="copyright">
                <div className="copyright-text">
                  <p className="mb-0">
                    Copyright © 2025 Howzit!. All Rights Reserved
                  </p>
                </div>
                <div className="copyright-menu">
                  <ul className="policy-menu">
                    <li>
                      <Link to="#">Legal Notice</Link>
                    </li>
                    <li>
                      <Link to="#">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="#">Refund Policy</Link>
                    </li>
                  </ul>
                </div>
                <ul className="payment-method">
                  <li>
                    <Link to="#">
                      <img src="assets/img/icons/card-01.svg" alt="Img" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <img src="assets/img/icons/card-02.svg" alt="Img" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <img src="assets/img/icons/card-03.svg" alt="Img" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <img src="assets/img/icons/card-04.svg" alt="Img" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <img src="assets/img/icons/card-05.svg" alt="Img" />
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <img src="assets/img/icons/card-06.svg" alt="Img" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer> */}
      </>

    </div>
  )
}

export default Footer
